export default {"src":"/_next/static/media/info-alert-icon.a867796f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};